import {BaseEntity} from "./BaseEntity";

export class Printer implements BaseEntity {
    constructor(
        public id?:number,
        public name?:string,
        public filepath?:string,
        public usewithservice?:string){
    }
    parseJson(json: any): void {
        this.id= json.id;
        this.name = json.name;
        this.filepath = json.filepath;
        this.usewithservice = json.useWithService;
    }
}
